import './bootstrap';

// For use with Laravel's forms (routes: 'specify.user.show' and 'municipality.identification')
import './components/form/form-disable-part';
import './components/form/placeholder-value-from';
import './components/common/tooltips';
import './components/common/svg-interactivity';

import { questionizer } from './components/common/questionizer';
import { surveyNavigatorScrollTrigger } from './components/common/surveyNavigatorScrollTrigger';
import { glossaryParser } from './components/common/glossary-parser';

questionizer.make('survey-main')
    .then(surveyNavigatorScrollTrigger)
    .then(() =>
    {
        glossaryParser.init();
    })
    .catch(reason =>
    {
        console.log(reason.message);
    });

var Raven = require('raven-js');
Raven.config('https://28eec2560bc44b21bbe8ec405da5fe76@sentry.io/161278').install();



// WEBPACK FOOTER //
// ./resources/assets/js/app.js